// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__5PjZ2"};